import React, { useState } from 'react';
import { Viewport } from '../Base/Sensors';

const withLazyLoad = (WrappedComponent) => {
  const LazyLoad = (props) => {
    const { CurrentPageProps, ImageUrl, isViewed } = props;
    const { IsEditMode } = CurrentPageProps;

    const [isLazyLoaded, setIsLazyLoaded] = useState(IsEditMode);
    const [currentSrc, setCurrentSrc] = useState(IsEditMode ? ImageUrl : null);

    const imgIsTouched = () => ImageUrl?.indexOf('?') > 0;

    const handleOnLoad = (e) => {
      const img = e.currentTarget;

      if (isViewed) {
        setIsLazyLoaded(true);
        setCurrentSrc(
          typeof img?.currentSrc !== 'undefined' ? img?.currentSrc : ImageUrl
        );
      }
    };

    const paramOrQuery = imgIsTouched() ? '&' : '?';
    const presetLowResUrl = `${ImageUrl}${paramOrQuery}preset=low-res`;
    const imageUrl = props.isViewed || IsEditMode ? ImageUrl : presetLowResUrl;
    return (
      <WrappedComponent
        isLazyLoad={!IsEditMode}
        handleOnLoad={handleOnLoad}
        LazyLoadImageUrl={imageUrl}
        {...props}
        {...{ isLazyLoaded, currentSrc }}
      />
    );
  };

  //Trigger load img with offset 200px
  return Viewport(LazyLoad, 200);
};

export default withLazyLoad;
